// internationalization
export const I18N_LOCAL_STORAGE_KEY = 'ce-app-i18n-locale'
export const I18N_DEFAULT_LOCALE = 'fr'

// all app routes
export const ROUTES = {
  REDIRECT: '/redirect',
  INDEX: '/', // if redirected to root, router will handle the redirections
  CREATE_PLATFORM: '/setup',
  PRIVACY: '/privacy',
  LOGIN_WITH_SAML: '/SAML',
  LOGOUT: '/logout',
  FORGOT_PASSWORD: (token?: string) => `/mot-de-passe-oublie/${token || ''}`,
  INVITATION: (token: string) => `/invitation/${token}`,
  DASHBOARD: '/dashboard',
  MESSAGES: (conversationId?: string) => (conversationId ? `/messages/${conversationId}` : '/messages'),
  CHAT: (conversationId?: string) => (conversationId ? `/chat/${conversationId}` : '/chat'),
  CHAT_BY_PROGRAM: (programId: string) => `/chat?programId=${programId}`,
  SESSIONS: '/sessions',
  USER: (userId: string) => `/user/${userId}`,
  PROFILE: '/profile',
  ADMIN: {
    EDIT_PROGRAM_SETTINGS: '/admin/program-settings/edit',
    NEW_PROGRAM_SETTINGS: '/admin/program-settings/new',
    REMINDERS: '/admin/reminders',
    DASHBOARD: '/admin/dashboard',
    GROUPS: '/admin/groups',
    USERS: '/admin/users',
    SESSIONS: '/admin/sessions',
    SETTINGS: '/admin/settings',
    SETUP: '/admin/setup',
    DOWNLOAD_DELIVERABLE: (sessionId: string, userId: string, deliverableId: string) =>
      `/admin/session/${sessionId}/user/${userId}/deliverable/${deliverableId}`,
  },
}

// reflect the media queries inside the css
export const BREAKPOINTS = {
  'MOBILE': 375,
  'TABLET': 768,
  'DESKTOP': 1024,
  '2K': 2560,
}

// Phone number modal
export const DO_NOT_ASK_PHONE_NUMBER_AGAIN = 'doNotAskPhoneNumberAgain'

// session review modal on uncompleted session
export const DO_NOT_ASK_REVIEW_AGAIN = 'doNotAskReviewAgain'

// analytics disabled key in order to disable all analytics tools when impersonating a user
export const ANALYTICS_DISABLED_KEY = 'constel-analytics-disabled'

// number of attempts to find a mentor
export const MENTOR_SEARCH_ATTEMPTS_KEY = 'constel-mentor-search-attempts'

// general constants
export const CONTACT_EMAIL = 'contact@constel-education.com'
export const PROFILE_PICTURE_BUCKET_URL = 'https://profil-picture.s3.fr-par.scw.cloud/'

// sessions constants
export const MAX_SESSIONS_PER_PAGE = 20
export const MAX_USERS_PER_PAGE = 20
export const MAX_GROUPS_PER_PAGE = 20

//reminders constants
export const MAX_CYCLES_PER_PAGE = 20

export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
